module.exports = __webpack_public_path__ + "img/bike_grey.3c580b65.svg";